import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import CustomProvider from "./Sections/CustomCursor/CustomCursor";

// bootstrap stylesheet..
import "bootstrap/dist/css/bootstrap.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <CustomProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </CustomProvider>
  </HelmetProvider>
);
